module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "epigraph-indented-space-after"
  }, [_c('em', [_vm._v("‘Patriotism is the last refuge of a scoundrel.’")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-source"
  }, [_vm._v("Samuel Johnson (1709–1784)")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-source"
  }, [_vm._v("James Boswell, "), _c('em', [_vm._v("Life of Johnson,")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-source"
  }, [_vm._v("entry for Friday, April 7, 1775")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21679962","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 78
// module chunks = 0